import React from "react";
import { X } from "lucide-react";

export const money2 = (n) =>
  `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }) : "—";

export const fmtDateTime = (iso) =>
  iso ? new Date(iso).toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : "—";

export function Modal({ title, children, onClose, testid }) {
  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center p-4" data-testid={testid}>
      <div className="absolute inset-0 bg-black/60" onClick={onClose} />
      <div className="relative w-full max-w-lg bg-[#0C111B] border border-white/10 rounded-2xl p-6 max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between mb-5">
          <h3 className="text-[16px] font-bold text-white">{title}</h3>
          <button onClick={onClose} className="p-1.5 rounded-lg text-slate-400 hover:bg-white/5" data-testid="modal-close"><X className="h-5 w-5" /></button>
        </div>
        {children}
      </div>
    </div>
  );
}

export function DInput({ label, type = "text", value, onChange, required, testid, placeholder }) {
  return (
    <div>
      <label className="block text-[11.5px] font-semibold text-slate-400 mb-1.5 uppercase tracking-wider">{label}</label>
      <input type={type} value={value} onChange={onChange} required={required} data-testid={testid} placeholder={placeholder}
        className="w-full h-10 px-3 rounded-lg bg-[#0F1623] border border-white/10 text-[13px] text-slate-200 placeholder:text-slate-600 focus:outline-none focus:ring-2 focus:ring-cyan-500/30" />
    </div>
  );
}

export function DSelect({ label, value, onChange, options, testid }) {
  return (
    <div>
      <label className="block text-[11.5px] font-semibold text-slate-400 mb-1.5 uppercase tracking-wider">{label}</label>
      <select value={value} onChange={onChange} data-testid={testid}
        className="w-full h-10 px-2 rounded-lg bg-[#0F1623] border border-white/10 text-[13px] text-slate-200 focus:outline-none focus:ring-2 focus:ring-cyan-500/30">
        {options.map(([v, l]) => <option key={v} value={v} className="bg-[#0F1623]">{l}</option>)}
      </select>
    </div>
  );
}

export function DTextarea({ label, value, onChange, rows = 4, testid, placeholder }) {
  return (
    <div>
      <label className="block text-[11.5px] font-semibold text-slate-400 mb-1.5 uppercase tracking-wider">{label}</label>
      <textarea value={value} onChange={onChange} rows={rows} data-testid={testid} placeholder={placeholder}
        className="w-full px-3 py-2 rounded-lg bg-[#0F1623] border border-white/10 text-[13px] text-slate-200 placeholder:text-slate-600 focus:outline-none focus:ring-2 focus:ring-cyan-500/30" />
    </div>
  );
}

export const STATUS_PILL = {
  active: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  trialing: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  past_due: "bg-rose-500/15 text-rose-300 border-rose-500/30",
  suspended: "bg-orange-500/15 text-orange-300 border-orange-500/30",
  canceled: "bg-slate-500/15 text-slate-400 border-slate-500/30",
  paid: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  sent: "bg-blue-500/15 text-blue-300 border-blue-500/30",
  void: "bg-slate-500/15 text-slate-400 border-slate-500/30",
};
